import { render, staticRenderFns } from "./alter.vue?vue&type=template&id=1610b5f6&scoped=true"
import script from "./alter.vue?vue&type=script&lang=js"
export * from "./alter.vue?vue&type=script&lang=js"
import style0 from "./alter.vue?vue&type=style&index=0&id=1610b5f6&prod&lang=less&scoped=true"
import style1 from "./alter.vue?vue&type=style&index=1&id=1610b5f6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1610b5f6",
  null
  
)

export default component.exports